class FiltersForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form#Filters-form');
        this.sectionId = this.dataset?.sectionId;
        this.section = document.getElementById(`shopify-section-${this.sectionId}`);
        this.resetLinks = this.section.querySelectorAll('a.js-filters-reset');
    }

    connectedCallback() {
        if (!this.form) {
            console.error('Filters Form not found');
            return;
        }

        if (!this.sectionId) {
            console.error('Section ID is required');
            return;
        }

        if (!this.section) {
            console.error(`Section with id ${this.sectionId} not found`);
            return;
        }

        this.form.addEventListener('submit', this.submitForm.bind(this));

        this.resetLinks.forEach(resetLink => {
            resetLink.addEventListener('click', this.resetFilters.bind(this));
        });
    }

    async resetFilters(e) {
        e.preventDefault();

        const link = e.target.closest('a');

        const fetchUrl = new URL(link.href);

        this.fetchContent(fetchUrl);
    }

    async submitForm(e) {
        e.preventDefault();

        const formData = new FormData(this.form),
            formDataString = new URLSearchParams(Array.from(formData.entries()).map(([key, value]) => `${key}=${value}`).join('&')).toString();

        const fetchUrl = new URL(`${this.form.action}${this.form.action.includes('?') ? '&' : '?'}${formDataString}`);

        this.fetchContent(fetchUrl);
    }

    async fetchContent(fetchUrl) {
        if (!fetchUrl || typeof fetchUrl !== 'object') {
            console.error('Fetch URL is required and must be a URL object');
            return;
        }

        const drawerContent = this.section.querySelector('.drawer-content');
        const scrollTop = drawerContent?.scrollTop ?? 0;
        const selectedView = this.section.querySelector('input[name="collection-view"]:checked')?.value;

        this.classList.add('is-loading');

        try {
            const newUrl = fetchUrl.href;

            fetchUrl.searchParams.set('sections', this.sectionId);

            const response = await fetch(fetchUrl);

            if (!response.ok) {
                console.error(`Failed to submit filters form: ${response.statusText}`);
                this.classList.remove('is-loading');
                return;
            }

            const data = await response.json(),
                updatedContent = data[this.sectionId];

            if (!updatedContent) {
                console.error('Updated content not found');
                this.classList.remove('is-loading');
                return;
            }

            const domparser = new DOMParser(),
                updatedContentDocument = domparser.parseFromString(updatedContent, 'text/html'),
                updatedSectionElement = updatedContentDocument.getElementById(`shopify-section-${this.sectionId}`);

            if (!updatedSectionElement) {
                console.error('Updated section element not found');
                this.classList.remove('is-loading');
                return;
            }

            if (selectedView === 'small') {
                updatedSectionElement.querySelector('input[name="collection-view"][value="small"]')?.setAttribute('checked', '');
                updatedSectionElement.querySelector('input[name="collection-view"][value="large"]')?.removeAttribute('checked');
            }

            const newFiltersForm = updatedSectionElement.querySelector('filters-form');
            const newFiltersDrawer = updatedSectionElement.querySelector('.js-filters-drawer');

            newFiltersForm?.classList.add('is-loading');
            if (newFiltersDrawer.classList.contains('mobile-only') && window.innerWidth < 1200 || !newFiltersDrawer.classList.contains('mobile-only')) {
                newFiltersDrawer?.setAttribute('open', '');
            }

            requestAnimationFrame(() => {
                try {
                    this.section.replaceWith(updatedSectionElement);

                    if (newFiltersDrawer.classList.contains('mobile-only') && window.innerWidth < 1200 || !newFiltersDrawer.classList.contains('mobile-only')) {
                        newFiltersDrawer?.removeAttribute('open');
                        newFiltersDrawer?.showModal();
                    }

                    const newDrawerContent = updatedSectionElement.querySelector('.drawer-content');

                    if (newDrawerContent) {
                        newDrawerContent.scrollTop = scrollTop;
                    }

                    newFiltersForm?.classList.remove('is-loading');

                    history.pushState(null, '', newUrl);
                } catch (error) {
                    console.error('Error replacing filters section: ', error);
                    newFiltersForm?.classList.remove('is-loading');
                }
            });

        } catch (error) {
            console.error('Error submitting filters form: ', error);
            this.classList.remove('is-loading');
        }
    }
}

if (!customElements.get('filters-form')) {
    customElements.define('filters-form', FiltersForm);
}